import { externalSolanaAddresses } from "./glyph-linked-wallet";

import type { LinkedAccountLike } from "./privy-account";

export interface GlyphWalletMembership {
  readonly userId: string | null;
  readonly addresses: readonly string[];
}
export interface GlyphWalletMembershipSource {
  getSnapshot: () => GlyphWalletMembership;
  subscribe: (listener: () => void) => () => void;
}
export const EMPTY_GLYPH_MEMBERSHIP: GlyphWalletMembership = {
  userId: null,
  addresses: [],
};

/** Provider-confirmed presentation data, independent of the session identity. */
export function createGlyphMembershipStore() {
  let snapshot = EMPTY_GLYPH_MEMBERSHIP;
  const listeners = new Set<() => void>();
  return {
    getSnapshot: () => snapshot,
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    publish: (
      userId: string | null,
      accounts: readonly LinkedAccountLike[]
    ) => {
      const addresses = userId ? externalSolanaAddresses(accounts) : [];
      if (
        snapshot.userId === userId &&
        snapshot.addresses.join(",") === addresses.join(",")
      )
        return;
      snapshot = { userId, addresses };
      for (const listener of listeners) listener();
    },
  };
}
